/**
 * Maps a student object from the onboarding API to the Formik kid shape.
 * @param {import("../../../../hooks/authV2/useGetOnboardingStudents").OnboardingStudent} student
 * @returns {object} Formik-compatible kid object with _id, _status, and has_transferred_progress
 */
export const mapStudentToKid = (student) => {
  const nameParts = (student.name || "").trim().split(/\s+/);
  const firstName = nameParts[0] || "";
  const lastName = nameParts.slice(1).join(" ") || "";

  return {
    _id: student.id,
    _status: "old",
    firstName,
    lastName,
    username: student.username || "",
    age: student.age ? String(student.age) : "",
    password: "",
    email: student.email || "",
    has_transferred_progress: student.has_transferred_progress || false,
  };
};

/**
 * Returns the display label for a billing cycle (e.g. "/year" or "/yr").
 * Defaults to "/year" when cycle is yearly, empty, or undefined.
 * @param {string} [billingCycle] - "yearly" | "monthly"
 * @param {"slash" | "short"} [format="slash"] - "slash" returns "/year", "short" returns "/yr"
 * @returns {string}
 */
export const getBillingPeriodLabel = (billingCycle, format = "slash") => {
  const isMonthly = billingCycle?.toLowerCase() === "monthly";
  if (isMonthly) {
    return format === "short" ? "/mo" : "/month";
  }
  return format === "short" ? "/yr" : "/year";
};
